import React from 'react';
import { Button } from '../../Components/UI/button';
import { getSubscriptionPlans, getAt99 } from '../../Utils/Utilities';

const FlashOfferCard = () => {
  if (!getAt99) return null;

	const scrollToSec = () => {
		scrollToSection('pkgAndPricing');
	};

	const scrollToSection = (sectionId) => {
		const element = document.getElementById(sectionId);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};


  return (
    <div className="w-full px-4 py-8 bg-sahi-disable pb-12">
      <div className="max-w-sm mx-auto">
        {/* Main Card */}
        <div className="bg-white rounded-2xl border-2 overflow-hidden">
          
          {/* Flash Offer Header */}
          <div className=" px-6 py-3 bg-sahi-green">
            <h2 className="text-xl font-semibold text-white text-center">
              Flash Offer!
            </h2>
          </div>

          {/* Divider */}
          {/* <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div> */}

          {/* Content */}
          <div className="px-6 py-5">
            
            {/* Start First Year Text */}
            <p className="text-gray-600 text-center text-sm font-medium mb-2">
              Start First Year @ Just
            </p>

            {/* Original Price (Strikethrough) */}
            <div className="text-center">
              <span className="text-gray-400 text-lg line-through font-medium">
                ₹1,200
              </span>
            </div>

            {/* Discounted Price */}
            <div className="text-center mb-2">
              <div className="flex items-baseline justify-center gap-2">
                <span className="text-sahi-dark-blue text-2xl font-medium">₹</span>
                <span className="text-6xl font-bold text-sahi-green tracking-tight">99</span>
                <span className="text-sahi-dark-blue text-lg font-semibold">only</span>
              </div>
            </div>

            {/* Package Info */}
            <p className="text-center text-gray-500 text-sm mb-5">
              (Full Package, Not Trial)
            </p>

            {/* CTA Button */}
            <Button
              onClick={scrollToSec}
              className="w-full bg-sahi-green text-white font-medium text-md py-4 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-200"
            >
              Get Offer
            </Button>

            {/* Bottom Divider */}
            <div className="my-4">
              <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
            </div>

            {/* Money Back Guarantee */}
            <p className="text-center text-sahi-green text-sm font-medium">
              7-Day Moneyback Guarantee
            </p>
          </div>

          {/* Bottom Accent Border */}
          {/* <div className="h-1 bg-gradient-to-r from-gray-500 via-gray-300 to-gray-500"></div> */}
        </div>

        {/* Shadow Effect */}
        <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-4/5 h-8 bg-sahi-green/10 blur-xl rounded-full -z-10"></div>
      </div>
    </div>
  );
};

export default FlashOfferCard;